import React from "react";
import Box from "@material-ui/core/Box";

export default function About() {
  return (
    <Box style={{ padding: "40px" }}>
      <h3>About tone of choice</h3>
      <br />
      <h5>What is transcreation and why is it important?</h5>
      <p>
        Transcreation is much more than translation. It’s the only way to avoid
        costly and embarrassing language issues and cringeworthy culture
        clashes.
      </p>
      <p>
        It takes the original message and conveys it in another language, making
        sure that the text in the target language keeps the original style,
        vocal tone, intent, and emotional salience. It is a combination of
        discipline and art, translation and interpretation. It is the process
        that re-evaluates the marketing material produced for a local market and
        re-configures it in order to appeal to an audience with a very different
        culture.
      </p>
      <p>
        {" "}
        The process of transcreation involves understanding the target market
        and carefully tailoring the message using suitable language, style
        imagery and tone for optimal appeal and effective messaging. This is the
        main reason why the process requires not only a good translator with
        linguistic skills but a translator with expertise in marketing and a
        firm grasp of the target audience’s culture.
      </p>
      <h5>What Tone of Choice offers</h5>
      <p>
        Tone of choice is a one of a kind platform that celebrates the artistry
        that is transcreation. Our translators are experienced professionals,
        that know the absolute importance of proper brand communication.
      </p>{" "}
      <p>
        With insights in their profiles and on demand availabilities and quotes,
        booking a reliable, professional transcreation has never been easier.
      </p>
    </Box>
  );
}
